export enum ArtifactType {
	Recordings = "recordings",
	Snapshots = "snapshots",
	Files = "files",
}
